import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
import useIsMobile from '@/hooks/useIsMobile';
import { Container, Typography } from '@pw-tech/omni-ui';
import React, { useContext } from 'react';
import { RegistrationContext } from '../../contexts/RegistrationContextProvider';
const Navbar = () => {
  const {
    selectedCourseData
  } = useContext(CourseContext);
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const isMobileScreen = useIsMobile();
  return <Container className="flex items-center justify-between px-4 py-4 mx-auto text-white md:py-6" data-sentry-element="Container" data-sentry-component="Navbar" data-sentry-source-file="Navbar.tsx">
      <div className="flex flex-col gap-1">
        <Typography variant="heading2" weight="bold" data-sentry-element="Typography" data-sentry-source-file="Navbar.tsx">
          My Application
        </Typography>
        <Typography variant={isMobileScreen ? 'small' : 'regular'} data-sentry-element="Typography" data-sentry-source-file="Navbar.tsx">
          {registrationDetails?.uniqueEnrollmentNumber ? `UEN: ${registrationDetails?.uniqueEnrollmentNumber ?? ''}` : ''}
        </Typography>
      </div>
      <div className="flex flex-col gap-2">
        <Typography variant={isMobileScreen ? 'regular' : 'heading4'} data-sentry-element="Typography" data-sentry-source-file="Navbar.tsx">
          {selectedCourseData?.crmProductName || ''}
        </Typography>
        <Typography variant={isMobileScreen ? 'small' : 'regular'} data-sentry-element="Typography" data-sentry-source-file="Navbar.tsx">
          {selectedCourseData?.metaData?.duration || ''}
        </Typography>
      </div>
    </Container>;
};
export default Navbar;